import { BaseWebComponentRepository } from '../../../../framework/BaseWebComponentRepository';
import { InProductTrialsAppDataProviderFactory } from '../factory/InProductTrialsAppDataProviderFactory';
import { InProductTrialsAppBaseDataProvider } from '../dataProvider/InProductTrialsAppBaseDataProvider';
import { AvailableInProductTrialsDetails } from '../types/AvailableInProductTrialsDetails';
import { AvailableProductTrialType } from '../../types/AvailableProductTrialType';
import {
  FetchProductBuyInitialDataFunction,
  FetchProductBuyPriceFunction,
  FetchProductBuyUrlFunction,
} from '../../types/ProductLandingPageBuyConfig';

export class InProductTrialsAppRepository extends BaseWebComponentRepository {
  public dataProviderFactory: InProductTrialsAppDataProviderFactory;
  public dataProvider: InProductTrialsAppBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new InProductTrialsAppDataProviderFactory(),
    });
  }

  public async getAvailableInProductTrials(): Promise<AvailableInProductTrialsDetails> {
    return this.dataProvider.getAvailableInProductTrials();
  }

  public async startInProductTrial(
    type: AvailableProductTrialType
  ): Promise<{ success: boolean; exceptionType?: string, trialType?: number, incompatibleProductIds?: number[] }> {
    return this.dataProvider.startInProductTrial(type);
  }

  public async requestInProductTrial(
    type: AvailableProductTrialType,
    remarks?: string
  ): Promise<{ success: boolean; companyAlreadyProvisioned?: boolean; errorMessage?: string }> {
    return this.dataProvider.requestInProductTrial(type, remarks);
  }

  public async cancelInProductTrial(
    type: AvailableProductTrialType
  ): Promise<{ success: boolean; errorMessage?: string }> {
    return this.dataProvider.cancelInProductTrial(type);
  }

  public async fetchProductBuyInitialData(
    type: AvailableProductTrialType
  ): ReturnType<FetchProductBuyInitialDataFunction> {
    return this.dataProvider.fetchProductBuyInitialData(type);
  }

  public async fetchProductBuyPrice(
    productType: AvailableProductTrialType,
    seatsCount: number,
    validityYears: number
  ): ReturnType<FetchProductBuyPriceFunction> {
    return this.dataProvider.fetchProductBuyPrice(productType, seatsCount, validityYears);
  }

  public async fetchProductBuyUrl(
    productType: AvailableProductTrialType,
    seatsCount: number,
    validityYears: number
  ): ReturnType<FetchProductBuyUrlFunction> {
    return this.dataProvider.fetchProductBuyUrl(productType, seatsCount, validityYears);
  }
}
